import React, { Fragment } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ItemBox from '../../components/itens/item';


function LicitacoesScreen() {
    return (
        <Fragment>
            <Head titulo="Licitações" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Fragment>
                    <Row xs={12} lg={2}>
                        <Col>
                            <ItemBox
                                titulo={"Todas licitações e dispensas"}
                                descricao={<Fragment><p>Clique aqui e veja a listagem completa de licitações e dispensas realizadas por essa prefeitura. Nesse item, você encontra desde os avisos de editais, até licitações homologadas, canceladas, suspensas e em andamento.</p><br /></Fragment>}
                                awesome={"faStore"}
                                link={"licitacao/todas"}
                            />
                        </Col>
                        <Col>
                            <ItemBox
                                titulo={"Avisos de Editais"}
                                descricao={<Fragment><p>Clique aqui e veja a listagem de avisos de editais de licitações e dispensas dessa prefeitura.</p><br /></Fragment>}
                                awesome={"faBullhorn"}
                                link={"licitacao/aviso"}
                            />
                        </Col>
                        <Col>
                            <ItemBox
                                titulo={"Licitações em Andamento"}
                                descricao={<Fragment><p>Clique aqui e veja a listagem de licitações e dispensas em andamento nessa prefeitura.</p><br /></Fragment>}
                                awesome={"faChartLine"}
                                link={"licitacao/andamento"}
                            />
                        </Col>
                        <Col>
                            <ItemBox
                                titulo={"Licitações Encerradas"}
                                descricao={<Fragment><p>Clique aqui e veja a listagem de licitações e dispensas já homologadas nessa prefeitura.</p><br /></Fragment>}
                                awesome={"faStoreSlash"}
                                link={"licitacao/encerradas"}
                            />
                        </Col>
                        <Col>
                            <ItemBox
                                titulo={"Documentos para Cadastro de Fornecedor"}
                                descricao={<Fragment><p>Clique aqui e veja a listagem dos documentos necessários para realizar o cadastramento de fornecedor nessa prefeitura.</p><br /></Fragment>}
                                awesome={"faIdCardAlt"}
                                link={"https://prefeituramacuco.rj.gov.br/transparencia/arquivos/docs/documentos-para-cadastro-de-fornecedor.pdf"}
                            />
                        </Col>
                        <Col>
                            <ItemBox
                                titulo={"Nova Lei de Licitações"}
                                descricao={<Fragment><p>Confira no link abaixo as minutas, documentos padrões e legislação referente à Nova Lei de Licitações no Município de Macuco</p><br /></Fragment>}
                                awesome={"faScaleBalanced"}
                                link={"https://prefeituramacuco.rj.gov.br/site/transparencia-e-acesso-a-informacao/legislacao-e-minutas-nova-lei-de-licitacoes-e-contratos.html"}
                            />
                        </Col>
                        <br />
                    </Row>
                </Fragment>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default LicitacoesScreen;